/* eslint-disable prettier/prettier */
import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import {Box, Fade, Flex, Text, useMultiStyleConfig} from '@chakra-ui/react'
import ProductTileBundle from './partials/product-tile-bundle'
import AddToCartButton from '../add-to-cart-button'
import CurrentPrice from '../display-price/current-price'
import { useCurrency } from '@salesforce/retail-react-app/app/hooks'
import {useBooleanCustomPreference} from '../../hooks/use-custom-preference'
import { FormattedMessage, useIntl } from 'react-intl'
import { API_ERROR_MESSAGE } from '../../constants'
import { remCalc } from '../../theme/_utils'

const Bundle = ({title, bundleDetails}) => {
    const styles = useMultiStyleConfig('Bundle')
    const {currency} = useCurrency()
    const notShoppableCountry = useBooleanCustomPreference('notShoppableCountry')

    const [showErrorMessage, setShowErrorMessage] = useState(0)
    const errorContainerRef = useRef(null)
    const {formatMessage} = useIntl()

    {/* Calculate the total price of the bundle */}
    const bundleTotalPrice = bundleDetails?.find(child => child.totalBundlePrice)?.totalBundlePrice || 0;

    {/* Retrieve the bundle id from one of the products */}
    const productSetId = bundleDetails.find(item => item.productSetID)?.productSetID;

    const bundlesData = bundleDetails.filter(item => !item.totalBundlePrice);

    return (
        <Flex {...styles.outerContainer} data-testid="bundle-product-view">
            <Text {...styles.headerLabel} data-testid="bundle-product-title">
                {title}
            </Text>
            <Flex {...styles.innerContainer}>
                <Flex sx={styles.productsContainer} data-testid="bundle-product-container">
                    {bundlesData.map((bundleData, i) => {
                        return(
                            <ProductTileBundle
                                key={i}
                                product={bundleData}
                                firstElement={i === 0}
                            />
                        )
                    })}
                </Flex>
            </Flex>
            <Flex 
                {...styles.addCartButtonContainer} 
                sx={{
                    width: {
                        base: '100%',
                        lg: `calc(25% * ${bundleDetails.length - 1})`,
                    }
                }}
            >
                <Flex {...styles.subtotalPrice}>
                    <FormattedMessage
                        defaultMessage="Subtotal:"
                        id="bundle_subtotal.text"
                    />
                    <CurrentPrice 
                        price={bundleTotalPrice} 
                        currency={currency} 
                        sx={{ 
                            whiteSpace: 'nowrap', 
                            textStyle: 'head-small', 
                            marginLeft: {base: 0, lg: remCalc(16)}, 
                            marginRight: {base: 0, lg: remCalc(16)} 
                        }}
                    />
                </Flex>
                {!notShoppableCountry && 
                (<Flex {...styles.addCartButton} data-testid="bundle-product-add-to-cart-button">
                    <AddToCartButton
                        product={bundlesData}
                        setShowErrorMessage={setShowErrorMessage}
                        errorContainerRef={errorContainerRef}
                        showUniversalFeedback={true}
                        bundleID={productSetId}
                    />
                </Flex>)}
            </Flex>
            <Box ref={errorContainerRef}>
                {showErrorMessage ? (
                    <Fade in={true}>
                        <Text color="text.danger" fontWeight={600} marginBottom={8}>
                            {formatMessage(API_ERROR_MESSAGE)}
                        </Text>
                    </Fade>
                ) : (
                    <></>
                )}
            </Box>
        </Flex>
    )
}

Bundle.propTypes = {
    bundle: PropTypes.object,
    bundleDetails: PropTypes.array,
    title: PropTypes.node,
}

export default Bundle
